import React from 'react'
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import "./common.css";

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 16,
      border: `1px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));
  
export default function CustomizedBadges(props) {
    return (
      <IconButton aria-label="cart" onClick={props.onClick}>
        <StyledBadge badgeContent={props.badgeContent} color="secondary">
          <ShoppingCartIcon />
        </StyledBadge>
      </IconButton>
    );
  }